/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { SOCIAL_PLATFORMS, SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { socialChannelStatusSchema } from '../social-channel-schema';

const regenPerDaySchema = z.object({
  date: z.string(),
  count: z.number(),
});

const publishPerDaySchema = z.object({
  date: z.string(),
  channelId: z.number(),
  count: z.number(),
});

const dashboardChannelSchema = z.object({
  id: z.number(),
  provider: z.enum(SOCIAL_PROVIDERS),
  platform: z.enum(SOCIAL_PLATFORMS),
  displayName: z.string(),
  status: socialChannelStatusSchema,
  publishedCount: z.number(),
});

export type ISocialDashboardRegenPerDay = z.infer<typeof regenPerDaySchema>;
export type ISocialDashboardPublishPerDay = z.infer<typeof publishPerDaySchema>;
export type ISocialDashboardChannel = z.infer<typeof dashboardChannelSchema>;

const dashboardDataSchema = z.object({
  videosReady: z.number(),
  publishedTotal: z.number(),
  published7d: z.number(),
  failed7d: z.number(),
  regenPerDay: z.array(regenPerDaySchema),
  publishPerDay: z.array(publishPerDaySchema),
  channels: z.array(dashboardChannelSchema),
});

export interface ISocialDashboardData {
  videosReady: number;
  publishedTotal: number;
  published7d: number;
  failed7d: number;
  regenPerDay: ISocialDashboardRegenPerDay[];
  publishPerDay: ISocialDashboardPublishPerDay[];
  channels: ISocialDashboardChannel[];
}

export const getSocialDashboardV1ResponseSchema = createApiResponseSchema(
  dashboardDataSchema,
) as z.ZodSchema<IAPI<ISocialDashboardData>>;

export type IGetSocialDashboardV1Response = IAPI<ISocialDashboardData>;
